import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ExploreBreedCategories from 'dpl/breed_explorer/components/BreedCategories';

function ExploreRelatedBreedCategoriesContainer(props) {
  if (props.categories.length === 0) {
    return null;
  }

  return (
    <div>
      <h6>Related Breeds</h6>
      <ExploreBreedCategories {...props} />
    </div>
  );
}

ExploreRelatedBreedCategoriesContainer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  categories: PropTypes.array.isRequired
};

export default connect(
  ({ server: { breedCategories } }, { breedCategorySlug }) => ({
    categories: breedCategories.data
      .find(b => b.slug === breedCategorySlug)
      .related_category_ids.map(id =>
        breedCategories.data.find(b => b.id === id)
      )
      .filter(Boolean)
  })
)(ExploreRelatedBreedCategoriesContainer);
